<div class="bg-white">
  <app-citizen-header
    (scrollToContainer)="scrollToContainer($event)"
    (msaadaAiClicked)="msaadaAiToggle = !msaadaAiToggle"
    [fromHomePortal]="true"
    [hasHomeButton]="false">
  </app-citizen-header>
  <app-portal-service-search
    (exitHover)="handleHover($event)" (mouseleave)="handleHover(null)"
    [ngClass]="activeMenu('service-search') ? 'block':'hidden'"
  ></app-portal-service-search>

  <app-portal-institution-search
    [searchedKeyword]="searchedInstitutionKeyword"
    (exitHover)="handleHover($event)"
    [ngClass]="activeMenu('institution-search') ? 'block':'hidden'"
  ></app-portal-institution-search>

  <div class="relative w-full min-h-[200px] flex items-center py-4 lg:py-6">
    <img src="/assets/images/hero-bg-image.png"
         alt="Hero"
         class="absolute inset-0 w-full h-full object-cover">
    <div class="absolute inset-0 bg-primary/70"></div>

    <div class="relative z-10 flex flex-col lg:flex-row gap-4 lg:gap-6 mx-auto justify-between items-stretch lg:items-center w-11/12">
      <div class="flex flex-col gap-3 lg:gap-4 justify-center w-full lg:flex-1 min-w-0">
        <div class="text-white flex flex-col gap-3 lg:gap-4 items-start">
          <div class="text-xl md:text-2xl lg:text-3xl font-bold leading-tight"
               data-aos="fade-up">
            {{ 'Karibu, Dirisha la Huduma za Serikali'|concat|translate }}
            <div class="inline-block border-r-2 border-yellow-400 md:h-12 h-6 me-2 align-middle"></div>
            <span class="text-yellow-400">
              <app-typewriter-text
                [texts]="['omba huduma…'|concat|translate, 'tafuta huduma…'|concat|translate]"></app-typewriter-text>
            </span>
          </div>

          <div class="w-full flex flex-col sm:flex-row gap-3 sm:gap-4 lg:max-w-3xl"
               data-aos="fade-up"
               data-aos-delay="150">
            <div (click)="handleHover('service-search')" (keyup)="$event.stopPropagation()"
                 class="w-full flex items-center bg-[#F8F9F9] px-3 py-2.5 rounded-lg min-w-0">
              <input (input)="onSearchChange()"
                     [formControl]="searchedKeyword"
                     (click)="handleHover('service-search')"
                     class="w-full outline-none bg-transparent text-black placeholder:text-[#B0AEAE]"
                     matInput
                     placeholder="{{'Tafuta Huduma'|concat|translate }}">
              <mat-icon svgIcon="landingSearch" class="text-gray-400 shrink-0" style="height:20px;width:20px"></mat-icon>
            </div>
            <div (click)="handleHover('institution-search')" (keyup)="$event.stopPropagation()"
                 class="w-full flex items-center bg-[#F8F9F9] px-3 py-2.5 rounded-lg min-w-0">
              <input (input)="onInstitutionSearchChange()"
                     [formControl]="searchedInstitutionKeyword"
                     (click)="handleHover('institution-search')"
                     class="w-full outline-none bg-transparent text-black placeholder:text-[#B0AEAE]"
                     matInput
                     placeholder="{{'Tafuta Taasisi'|concat|translate }}">
              <mat-icon svgIcon="landingSearch" class="text-gray-400 shrink-0" style="height:20px;width:20px"></mat-icon>
            </div>
          </div>
        </div>
      </div>

      <div class="w-full lg:w-[min(100%,22rem)] xl:w-[min(100%,26rem)] shrink-0 self-center lg:self-auto"
           direction="right"
           appSequentialAnimate>
        <div class="hero-stats-panel text-gray-100"
             (mouseenter)="onStatsPanelHover(true)"
             (mouseleave)="onStatsPanelHover(false)">
          <div class="flex items-center gap-1.5">
            <div>
              <button
                (click)="prevStatsSlide()"
                type="button"
                class="hidden sm:flex stats_button items-center justify-center shrink-0 bg-yellow-400 text-black p-1 rounded-full shadow hover:bg-yellow-500 transition"
                aria-label="Previous stats">
                <mat-icon class="!h-4 !w-4">chevron_left</mat-icon>
              </button>
            </div>

            <div
              class="grid grid-cols-2 gap-2 flex-1 min-w-0"
              [attr.key]="statCardsKey">
              @for (stat of activeStats; track stat.label) {
                <div
                  class="hero-stats-card flex flex-col gap-1 min-w-0 h-full"
                  [attr.data-aos-delay]="$index * 100"
                  direction="right"
                  appSequentialAnimate>
                  <div class="flex items-center gap-2">
                    <span class="shrink-0 inline-flex items-center justify-center">
                      <mat-icon [svgIcon]="stat.icon" class="!text-xl text-yellow-400"></mat-icon>
                    </span>
                    <div class="text-base lg:text-lg font-bold leading-none">{{ stat.count }}</div>
                  </div>
                  <div class="text-[10px] sm:text-xs leading-snug break-words">{{ stat.label | concat | translate }}</div>
                </div>
              }
            </div>

            <button
              (click)="nextStatsSlide()"
              type="button"
              class="hidden sm:flex stats_button shrink-0 bg-yellow-400 text-black p-1 rounded-full shadow hover:bg-yellow-500 transition"
              aria-label="Next stats">
              <mat-icon class="!h-4 !w-4">chevron_right</mat-icon>
            </button>
          </div>

          @if (getStatTotalSlides() > 1) {
            <div class="flex items-center justify-center gap-1 mt-2 sm:hidden">
              <button
                (click)="prevStatsSlide()"
                type="button"
                class="bg-yellow-400 text-black p-1 rounded-full"
                aria-label="Previous stats">
                <mat-icon class="!text-base !h-4 !w-4">chevron_left</mat-icon>
              </button>
              <span class="text-[10px] text-white/80">{{ currentStatSlide + 1 }}/{{ getStatTotalSlides() }}</span>
              <button
                (click)="nextStatsSlide()"
                type="button"
                class="bg-yellow-400 text-black p-1 rounded-full"
                aria-label="Next stats">
                <mat-icon class="!text-base !h-4 !w-4">chevron_right</mat-icon>
              </button>
            </div>
          }
        </div>
      </div>
    </div>
  </div>

  <app-help-utility [msaadaAiToggle]="msaadaAiToggle"></app-help-utility>
  <div>
    <app-portal-popular-services-view></app-portal-popular-services-view>
  </div>

  <div appScrollAnimate>
    <app-portal-static-sites></app-portal-static-sites>
  </div>

  <div appScrollAnimate class="w-11/12 mx-auto px-6 py-8" data-aos="fade-up">
    <div class="relative min-h-[260px] md:min-h-[300px] w-full flex items-center rounded-md overflow-hidden">
      <img src="/assets/images/mobilePatternAd.jpg"
           alt=""
           class="absolute inset-0 w-full h-full filter blur-sm object-cover">

      <div class="bg-[#0E205EE5] absolute inset-0"></div>

      <div class="relative z-10 h-full flex flex-col gap-1 justify-center w-6/12  py-8 px-10 md:px-16 ">
        <p class="text-md sm:text-lg md:text-2xl font-bold text-white leading-loose">
          {{ "Pata Huduma zote za serikali kiganjani mwako kupitia Aplikesheni yetu ya simu au kwa kupiga"|concat|translate }}
        </p>
        <p class="md:text-5xl sm:text-2xl text-lg font-bold text-secondary-500">
          *152*00#
        </p>

        <div class="flex flex-col gap-2">
          <div class="md:text-xl sm:text-lg text-md text-white">
            {{ ' Pakua kupitia' |concat|translate }} :
          </div>
          <div class="flex  gap-2">
            <div class="flex items-center gap-1  text-secondary-500">
              <mat-icon svgIcon="playStore"></mat-icon>
              <span>Google Play</span>
            </div>
            <div class="flex items-center gap-1  text-secondary-500">
              <mat-icon svgIcon="appleStore"></mat-icon>
              <span>App Store</span>
            </div>
          </div>
        </div>
      </div>
      <div class="w-6/12 z-10 flex justify-end">
        <img src="/assets/images/mockPhone.png"
             alt=""
             class=" inset-0 mockPhone ">
      </div>
    </div>
  </div>

  <app-portal-footer appScrollAnimate></app-portal-footer>

  <button
    id="backToTopBtn"
    type="button"
    (click)="scrollToTop()"
    [class.visible]="showBackToTop"
    aria-label="Back to top">
    <mat-icon svgIcon="backToTopIcon"></mat-icon>
  </button>

</div>
